import cache from './portal-cache'
import file from './file'
import subcontent from './subcontent'
import role from './role' //권한추가
import auth from './auth'

export default { cache, file, subcontent, role, auth } //role 추가
